import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useRef, useState } from 'react';
import Animate from '../../ui/Animate';
import FaqCategoryRow from './FaqCategoryRow';
const AdminFaqList = ({ categories, onSortChanged, onEditCategory, onDeleteCategory, isCategoryEditing, renderCategoryEditForm, renderItemsSlot, }) => {
    const [sortedCategories, setSortedCategories] = useState(categories);
    const [expandedIds, setExpandedIds] = useState(new Set());
    const categoryRefs = useRef({});
    const animateRef = useRef(null);
    // Sync local sortedCategories to the canonical prop. Whenever the page
    // reseeds (after a successful create / update / save-order / delete), the
    // list re-renders with the server-sourced order. Local ↑↓ swaps win until
    // the next prop update.
    useEffect(() => {
        setSortedCategories(categories);
    }, [categories]);
    const moveCategory = (index, direction) => {
        const targetIndex = direction === 'up' ? index - 1 : index + 1;
        if (targetIndex < 0 || targetIndex >= sortedCategories.length) {
            return;
        }
        // FLIP: snapshot DOM positions BEFORE the state mutation so the post-render
        // useLayoutEffect inside <Animate> can compute deltas and play the swap.
        animateRef.current?.capture();
        setSortedCategories((prev) => {
            const next = [...prev];
            [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
            return next;
        });
        const swapped = [...sortedCategories];
        [swapped[index], swapped[targetIndex]] = [swapped[targetIndex], swapped[index]];
        onSortChanged(swapped.map((c) => c.uid));
    };
    const toggleExpand = (uid) => {
        setExpandedIds((prev) => {
            const next = new Set(prev);
            if (next.has(uid)) {
                next.delete(uid);
            }
            else {
                next.add(uid);
            }
            return next;
        });
    };
    return (_jsx("div", { className: "admin-faq-list", children: _jsx(Animate, { refs: categoryRefs, ref: animateRef, children: sortedCategories.map((category, index) => {
                const editing = isCategoryEditing?.(category) ?? false;
                if (editing && renderCategoryEditForm) {
                    return (_jsx("div", { ref: (el) => {
                            categoryRefs.current[category.uid] = el;
                        }, className: "faq-category-row faq-category-row--editing", children: renderCategoryEditForm(category) }, category.uid));
                }
                const isExpanded = expandedIds.has(category.uid);
                return (_jsx(FaqCategoryRow, { ref: (el) => {
                        categoryRefs.current[category.uid] = el;
                    }, category: category, isExpanded: isExpanded, onToggleExpand: () => toggleExpand(category.uid), onEdit: () => onEditCategory(category.uid), onDelete: () => onDeleteCategory(category.uid), onMove: (direction) => moveCategory(index, direction), disableUp: index === 0, disableDown: index === sortedCategories.length - 1, itemsSlot: isExpanded ? renderItemsSlot?.(category) : undefined }, category.uid));
            }) }) }));
};
export default AdminFaqList;
